import { RootState } from '@reducers';

export const selectCancerPolicyClaim = (state: RootState) => state.userDashboardRouteReducer.policyClaim.cancerPolicyClaim;
